export default {
    TEXT: 'labels',
    DATE: 'labels',
    RADIO: 'optionList'
  }
  